export default "__VITE_ASSET__CD8kl1Ub__"